export enum aiResType {
    preset = 0,
    templateCase = 1,
    thinking = 2,
    text = 3,
    textRefresh = 4,
    hotShape = 5,
    marketAnalysis = 6,
    userAnalysis = 7,
    withTools = 8,
    flowAnalysis = 9,
    textCheck = 10,
    helpMsg = 11,
    flowImprove = 12,
    example,
    holidayText,
    diagramAnalyseSuggest,
}
export enum aiStatusType {
    flowchartAnalyse = 1,
    flowchartExplain,
    flowchartOptimize,
    flowchartOptimizePart,
    flowchartOptimizeSupply,
    flowchartOptimizeAdd,
    ganttSummarize,
    ganttExpirence,
    ganttRisk,
    ganttProgress,
    graphAnalyse,
    graphPredict,
    graphSummary,
    graphAbnormal,
    graphCompare,
    orgAnalyse,
    orgDiagnosis,
    ganttChat,
    graphChat,
    orgChat,
    flowchartChat,
}
export enum userMsgType {
    text = 0,
    file = 1,
    picture = 2,
}

export const analyseModeMap: Map<aiStatusType, string> = new Map([
    [aiStatusType.flowchartAnalyse, "flowchart-det-v"], // 流程图检测-图片分析
    [aiStatusType.flowchartExplain, "flowchart-desc-v"], // 流程图说明-图片分析
    [aiStatusType.flowchartOptimize, "flowchart-opt-v"], // 流程图优化-图片分析
    [aiStatusType.flowchartChat, "flowchart-chat-v"], // 流程图通用-图片分析
    // map.set(aiStatusType.flowchartOptimizePart, "flowchart-optimize-part");
    // map.set(aiStatusType.flowchartOptimizeSupply, "flowchart-optimize-supply");
    // map.set(aiStatusType.flowchartOptimizeAdd, "flowchart-optimize-add");
    [aiStatusType.ganttSummarize, "gantt-ovw-v"], // 甘特图项目概述-图片分析
    [aiStatusType.ganttExpirence, "gantt-exp-v"], // 甘特图项目经验分享-图片分析
    [aiStatusType.ganttRisk, "gantt-risk-v"], // 甘特图风险识别-图片分析
    [aiStatusType.ganttProgress, "gantt-prog-v"], // 甘特图项目进展-图片分析
    [aiStatusType.ganttChat, "gantt-chat-v"], // 甘特图通用-图片分析
    [aiStatusType.graphAnalyse, "graph-analyse"], // 表格分析
    [aiStatusType.graphPredict, "graph-trend-v"], // 图表趋势预测-图片分析
    [aiStatusType.graphSummary, "graph-summ-v"], // 图表概括总结-图片分析
    [aiStatusType.graphAbnormal, "graph-anon-v"], // 图表异常识别-图片分析
    [aiStatusType.graphCompare, "graph-comp-v"], // 图表数据对比-图片分析
    [aiStatusType.graphChat, "graph-chat-v"], // 图表通用-图片分析
    [aiStatusType.orgDiagnosis, "org-diag-v"], // 组织架构图组织诊断-图片分析
    [aiStatusType.orgAnalyse, "org-anal-v"], // 组织架构图组织分析-图片分析
    [aiStatusType.orgChat, "org-chat-v"], // 组织架构图通用-图片分析
]);
